/**
 * @format
 * @description Interactive article page
 */
export default {
  // available-slots-for-tier: {
  //   html: [],
  //   ldbd: [],
  //   flex: [],
  //   flex2: [],
  //   flex3: [],
  //   flex4: [],
  //   flex5: [],
  //   flex6: [],
  //   flex7: [],
  //   flex8: [],
  //   flex9: [],
  //   flex10: [],
  //   btyb: []
  // },
  mobile: {
    html: [[1, 1]],
    flex: [
      [300, 250],
      [320, 250],
      [320, 450]
    ],
    flex2: [
      [300, 250],
      [300, 600],
      [320, 600]
    ],
    flex3: [[300, 250]],
    flex4: [[300, 250]],
    flex5: [[300, 250]],
    flex6: [[300, 250]],
    flex7: [[300, 250]],
    flex8: [[300, 250]],
    flex9: [[300, 250]],
    flex10: [[300, 250]],
    btyb: [[160, 30]]
  },
  portrait: {
    html: [[1, 1]],
    ldbd: [
      [728, 90],
      [768, 250],
      [768, 450]
    ],
    flex: [
      [300, 250],
      [728, 90]
    ],
    flex2: [
      [300, 250],
      [728, 90],
      [768, 600]
    ],
    flex3: [
      [300, 250],
      [728, 90]
    ],
    flex4: [
      [300, 250],
      [728, 90]
    ],
    flex5: [
      [300, 250],
      [728, 90]
    ],
    flex6: [
      [300, 250],
      [728, 90]
    ],
    flex7: [
      [300, 250],
      [728, 90]
    ],
    flex8: [
      [300, 250],
      [728, 90]
    ],
    flex9: [
      [300, 250],
      [728, 90]
    ],
    flex10: [
      [300, 250],
      [728, 90]
    ],
    btyb: [[160, 30]]
  },
  landscape: {
    html: [[1, 1]],
    ldbd: [
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250],
      [1000, 250],
      [1024, 250],
      [1024, 450]
    ],
    flex: [
      [300, 250],
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250]
    ],
    flex2: [
      [300, 250],
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250],
      [1024, 600]
    ],
    flex3: [
      [300, 250],
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250]
    ],
    flex4: [
      [300, 250],
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250]
    ],
    flex5: [
      [300, 250],
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250]
    ],
    flex6: [
      [300, 250],
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250]
    ],
    flex7: [
      [300, 250],
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250]
    ],
    flex8: [
      [300, 250],
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250]
    ],
    flex9: [
      [300, 250],
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250]
    ],
    flex10: [
      [300, 250],
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250]
    ],
    btyb: [[160, 30]]
  },
  desktop: {
    html: [[1, 1]],
    ldbd: [
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250],
      [1000, 250],
      [1800, 250],
      [1800, 450]
    ],
    flex: [
      [300, 250],
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250],
      [1000, 250]
    ],
    flex2: [
      [300, 250],
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250],
      [1000, 250],
      [1024, 600]
    ],
    flex3: [
      [300, 250],
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250]
    ],
    flex4: [
      [300, 250],
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250]
    ],
    flex5: [
      [300, 250],
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250]
    ],
    flex6: [
      [300, 250],
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250]
    ],
    flex7: [
      [300, 250],
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250]
    ],
    flex8: [
      [300, 250],
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250]
    ],
    flex9: [
      [300, 250],
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250]
    ],
    flex10: [
      [300, 250],
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250]
    ],
    btyb: [[160, 30]]
  }
};
